import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

import BasicLayout from 'components/BasicLayout';
import TripCard, { ShimmerTripCard } from 'components/TripCard';
import TravelDetailsContainer from 'containers/TravelDetails';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelDetails } from 'models/travelDetails';

import RequestStatusInfo from '../../components/RequestStatusInfo';
import { Channel, ChannelInfo, Container, Countries, Country, Detail, Header, MailIcon, PhoneIcon } from './styles';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

function getItineraryId(travelDetails?: TravelDetails) {
  return travelDetails
    ? travelDetails.air
      ? travelDetails.air.orderNumber
      : travelDetails.vehicle
      ? travelDetails.vehicle.orderNumber
      : travelDetails.hotel?.orderNumber
    : '';
}

const TripSupport = () => {
  const companyConfiguration = useSelector((state: RootState) => state.companyConfiguration.configuration);
  const { t } = useStoreTranslation();
  
  const useZendeskChat = companyConfiguration?.script3CX?.trim()
                          ? companyConfiguration.script3CX
                          : undefined;

  const get3CXWidget = () => {
    
    if (useZendeskChat === undefined) {
      return `<call-us-selector phonesystem-url="https://cellvozirld.3cx.co" minimized="false" party="${companyConfiguration?.script3CX ?? 'LiveChat955047'}" style="position:fixed;font-size:16px;line-height:17px;z-index: 99999;--call-us-main-accent-color:${companyConfiguration?.primaryBackgroundColor};--call-us-main-background-color:#FFFFFF;--call-us-plate-background-color:${companyConfiguration?.primaryBackgroundColor};--call-us-plate-font-color:#E6E6E6;--call-us-main-font-color:#292929;--call-us-agent-bubble-color:#29292910;right: 50%; bottom: 20px;"></call-us-selector>`;
    }
    else {
      const existing = document.getElementById('ze-snippet');

      if (!existing) {
        const scriptKey = companyConfiguration?.script3CX?.trim()
                          ? companyConfiguration.script3CX
                          : 'ff58569d-f6bd-483f-8462-ecd256a30d7a';

        const script = document.createElement('script');
        script.id = 'ze-snippet';
        script.src = `https://static.zdassets.com/ekr/snippet.js?key=${scriptKey}`;
        document.body.appendChild(script);
      }
    }    
  };

  const getWhatsAppWidget = () =>
    `<a href="https://api.whatsapp.com/send?phone=${companyConfiguration?.menuView?.useWhatsappSupport}&text=${companyConfiguration?.menuView?.useWhatsappSupportMessage}" target="_blank" style="position:fixed;font-size:16px;line-height:17px;z-index: 99999;right: 3%; bottom: 32px;"><img src="/corporate/images/whatsapp-active.svg" alt="WhatsApp" style="width: 50px; height: 50px;"/></a>`;

  const renderChat = () =>
    companyConfiguration?.menuView?.useWhatsappSupport === '' ||
    companyConfiguration?.menuView?.useWhatsappSupport === null ||
    companyConfiguration?.menuView?.useWhatsappSupport === undefined
      ? get3CXWidget()
      : getWhatsAppWidget();

  const email = useMemo(
    () => companyConfiguration?.email || 'serviciosalclientecorp@netviajes.com.co',
    [companyConfiguration],
  );

  const phone = useMemo(
    () => companyConfiguration?.phone || '',
    [companyConfiguration],
  );
  
  const { id } = useParams<{ id: string }>();

  const [detailsOpen, setDetailsOpen] = useState(false);

  return (
    <TravelDetailsContainer
      travelId={id}
      render={(loading, travelDetails) => (
        <BasicLayout
          title={t('customerSupport.title')}
          subtitle={t('customerSupport.tripSubtitle', { itineraryId: getItineraryId(travelDetails) })}
        >
          {!loading && !!travelDetails ? (
            <TripCard
              travel={travelDetails}
              onToggle={(status) => {
                setDetailsOpen(status);
              }}
              detailsOpen={detailsOpen}
              render={(_, expirationTime, isExpiring, isAir) => (
                <RequestStatusInfo
                  travelId={id}
                  status={travelDetails.requester.status}
                  travelDetails={travelDetails}
                  expirationTime={expirationTime}
                  isExpiring={isExpiring}
                  isAir={isAir}
                />
              )}
            />
          ) : (
            <ShimmerTripCard />
          )}
          <Container>
            <Header>{t('customerSupport.contact.title')}</Header>
            <Detail>{t('customerSupport.contact.subtitle')}</Detail>
            <Countries>
              <Country>
                <Channel>
                  <MailIcon />
                  <ChannelInfo>{email}</ChannelInfo>
                </Channel>
                {phone ? (
                  <Channel>
                    <PhoneIcon />
                    <ChannelInfo>{phone}</ChannelInfo>
                  </Channel>
                ) : (<></>)}
              </Country>
            </Countries>
            { useZendeskChat ? renderChat() : <div dangerouslySetInnerHTML={{ __html: renderChat() }}></div>}
          </Container>
        </BasicLayout>
      )}
    />
  );
};

export default TripSupport;
